import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { SmsService } from '../services/sms.service';
import { ZuoraService } from '../services/zuora.service';
import { AuthService } from '@auth0/auth0-angular';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-pop-up',
  standalone: true,
  imports: [MatIconModule],
  templateUrl: './pop-up.component.html',
  styleUrl: './pop-up.component.scss',
})
export class PopUpComponent implements OnInit {
  constructor(
    private dialogRef: MatDialogRef<PopUpComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private smsService: SmsService,
    private zuoraService: ZuoraService,
    private authService: AuthService
  ) {}

  userCode: number = 0;
  token: string = '';
  accountNumber = [];
  userCreateValue: string = '';

  close(): void {
    this.dialogRef.close();
  }

  updateUserSelection(selection: string) {
    this.close();
    this.smsService
      .getUserCode(this.token, this.data.emailAddress)
      .subscribe((response) => {
        this.userCode = response.data[0].usersDwId;

        this.authService.getAccessTokenSilently().subscribe((tokenResponse) => {

          const requestBody = {
            fkUsersDwId: this.userCode,
            status: selection,
            isEnable: 'Y',
          };

          this.smsService
            .modifyUserSelection(this.token, requestBody)
            .subscribe({
              next: (response) => {
                console.log('updated');
              },
              error: (errorResponse: HttpErrorResponse) => {
                alert("Something went wrong. Please try again.");
              }
            });
        });
      });
  }

  ngOnInit(): void {
    this.authService.getAccessTokenSilently().subscribe((response) => {
      this.token = response;
    });
  }
}
